import { useRef, useState, useEffect } from "react";
import {
  postAttachment,
  useSendMessageMutation,
} from "../../redux/service/messages_service";
import {
  ProgressBarPp,
  getAttachmentURL,
  parseResponse,
} from "../../utils/common_lib";
import { getLoggedinUser, getUser } from "../../userStore";
import { Icon } from "../../utils/icons";
import { useFieldArray, useForm } from "react-hook-form";
import { CheckBox } from "../../components/ReactHooksFormFields/checkBox";
import { TextareaPp } from "../../components/ReactHooksFormFields/TextareaPp";
import { toast } from "react-toastify";
import DropDown from "../../components/DropDown";
import { getFileUuid, invalidMsg, validateFileType } from "./messages_lib";
import { MsgAttachment } from "./message_attachments";
import { hasActionRightsPracticePatient } from "../../userStore";
export const MessageForm = (props) => {
  const [hasError, setHasError] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [uploadType, setUploadType] = useState("");
  const [uploadProgress, setUploadProgress] = useState("");
  const [attachments, setAttachments] = useState({});
  const [isMessageRequired, setIsMessageRequired] = useState(false);
  const [messagePlaceholder, setMessagePlaceholder] = useState("Enter Message");
  const [messageRequiredError, setMessageRequiredError] = useState(false);

  const fileInputRef = useRef(null);

  const getActions = () => {
    if (props.defaultMessages?.length > 0) {
      return props.defaultMessages.map(msg => ({
        value: msg.title,
        slug: msg.slug,
        option_instruction: msg.option_instruction || "",
        option_placeholder: msg.option_placeholder || "",
        msg_required: msg.msg_required || false
      }));
    }
    return [];
  };

  const { ...formHandler } = useForm({
    defaultValues: {
      actions: getActions(),
      comments: "",
    },
  });
  const { fields: rows } = useFieldArray({
    control: formHandler.control,
    name: "actions",
  });

  useEffect(() => {
    if (props.defaultMessages?.length > 0) {
      formHandler.reset({
        actions: props.defaultMessages.map(msg => ({
          value: msg.title,
          slug: msg.slug,
          option_instruction: msg.option_instruction || "",
          option_placeholder: msg.option_placeholder || "",
          msg_required: msg.msg_required || false
        })),
        comments: "",
      });
    }
  }, [props.defaultMessages]);

  const updateMessageRequirements = () => {
    const values = formHandler.getValues();
    const selectedActions = values.actions?.filter((action) => action.selected) || [];
    const requiredAction = selectedActions.find((action) => action.msg_required);
    
    if (requiredAction) {
      setIsMessageRequired(true);
      if (requiredAction.option_placeholder) {
        setMessagePlaceholder(requiredAction.option_placeholder);
      }
    } else {
      setIsMessageRequired(false);
      setMessagePlaceholder("Enter Message");
    }
  };

  const [postMessage, { isLoading }] = useSendMessageMutation();
  const sessionUser = getLoggedinUser();
  const patient = getUser();

  const getPostData = () => {
    const values = formHandler.getValues();
    const actions = values.actions.filter((action) => action.selected);
    const attachmentKeys = Object.keys(attachments);
    if (
      actions?.length ||
      (values.comments && values.comments != "") ||
      attachmentKeys.length
    ) {
      return {
        token: sessionUser.token,
        sender_id: sessionUser.user_id,
        pid: patient.pid,
        message_type: "message",
        is_urgent: values.is_urgent || false,
        body: `${actions.map((action) => action.value).join(". ")}.\n\n\n${
          values.comments || ""
        }`,
        attachments: attachmentKeys
          .map((attKey) => attachments[attKey].attachment_id)
          .join(","),
        default_message: actions.map((action) => action.slug).filter(Boolean).join(","),
      };
    }
    return null;
  };
  const resetForm = () => {
    setAttachments({});
    setSubmitted(false);
    setHasError(false);
    setUploadType("");
    setIsMessageRequired(false);
    setMessagePlaceholder("Enter Message");
    setMessageRequiredError(false);
    formHandler.reset({
      actions: getActions(),
      comments: "",
    });
  };
  const validateForm = () => {
    updateMessageRequirements();
    const data = getPostData();
    if (data) {
      setHasError(false);
    } else {
      setHasError(true);
    }
  };
  const sendMessage = async () => {
    setSubmitted(true);
    setMessageRequiredError(false);
    const values = formHandler.getValues();
    const selectedActions = values.actions?.filter((action) => action.selected) || [];
    const requiredAction = selectedActions.find((action) => action.msg_required);
    
    if (requiredAction && (!values.comments || values.comments.trim() === "")) {
      setMessageRequiredError(true);
      return;
    }
    
    const postData = getPostData();
    if (!postData) {
      setHasError(true);
      return;
    }
    const res = await postMessage(postData);
    const { msg, code } = parseResponse(res);
    if (code == 0) {
      resetForm();
      toast.success(msg);
      if (props?.afterSubmit) {
        props?.afterSubmit();
      }
    } else {
      toast.error(msg);
    }
  };
  const triggerUpload = (type) => {
    fileInputRef.value = "";
    setUploadType(type);
    fileInputRef.current.click();
  };
  const uploadEvent = (event) => {
    const type = uploadType;
    let fileList = event.target.files;
    if (fileList.length > 0) {
      setHasError(false);
      let file = fileList[0];
      var ext = file.name
        .slice(-5)
        .match(/\.(.+)$/)[1]
        .toLowerCase();
      const valid = validateFileType(ext, type);
      if (!valid) {
        let msg = "";
        msg +=
          "<p>It is either not " +
          (type == "image" ? "an" : "a") +
          " " +
          type +
          " file or an unsupported extension is given.</p>";
        msg += "<p>" + invalidMsg[type] + "</p>";
        toast.error("Invalid attachment type. " + invalidMsg[type]);
      } else {
        const callbacks = {
          onStateChange: (res) => {
            const { data, code, msg } = parseResponse(res);
            if (code == 0) {
              toast.success(msg);
              console.log("data on state change---", data);
              if (type == "doc") {
                setAttachments((prev) => {
                  return {
                    ...prev,
                    doc: {
                      attachment_id: data.attachment_id,
                      url: getAttachmentURL(getFileUuid(data), "doc"),
                      type: "doc",
                    },
                  };
                });
              } else {
                setAttachments((prev) => {
                  return {
                    ...prev,
                    [type]: {
                      attachment_id: data.attachment_id,
                      url: getAttachmentURL(data?.attachment_id, "video"),
                      thumb:
                        type == "image"
                          ? getAttachmentURL(
                              data.attachment_id,
                              "image",
                              100,
                              100
                            )
                          : "",
                      type: type,
                    },
                  };
                });
              }
              event.target.value = null;
              fileInputRef.value = null;
            } else {
              toast.error(msg);
            }
            setUploadProgress("");
            setUploadType("");
          },
          onError: (error) => {
            toast.error(error);
            setUploadType("");
          },
          onProgress: (data) => {
            setUploadProgress(data.value);
          },
        };
        const uploadType = type == "doc" ? ext : type;
        postAttachment(file, uploadType, callbacks);
      }
    }
  };
  const removeAttachment = (key) => {
    fileInputRef.value = null;
    setAttachments((prev) => {
      let prevAttachs = { ...prev };
      delete prevAttachs[key];
      return prevAttachs;
    });
  };
  const attachmentMenu = [
    { label: "Image", onClick: () => triggerUpload("image") },
    { label: "Video", onClick: () => triggerUpload("video") },
    { label: "PDF", onClick: () => triggerUpload("doc") },
  ];
  const urgent_message = hasActionRightsPracticePatient(
    "urgent_messages",
    "add"
  );
  return (
    <>
      <div className="text-start mb-3">
        <h3 className="text-base font-semibold leading-6 text-gray-900">
          New Message
        </h3>
        <p>
          Please use messages for non-urgent communication only. If this is an
          urgent or emergent patient care issue, please call{" "}
          <strong>911</strong> or go to the nearest emergency room.
        </p>

        {hasError && submitted && !messageRequiredError ? (
          <p className="text-red-400 p-2 bg-amber-50 border border-amber-200 text-sm mt-2">
            Please select option/write Text message or attach an
            Image/Audio/Video
          </p>
        ) : (
          ""
        )}
        {messageRequiredError ? (
          <p className="text-red-400 p-2 bg-amber-50 border border-amber-200 text-sm mt-2">
            Message is required for the selected option
          </p>
        ) : (
          ""
        )}
      </div>
      <div className="py-5">
        {rows.map((action, actionIndex) => {
          return (
            <CheckBox
              key={actionIndex}
              title={
                <>
                  {action.value}
                  {action.option_instruction && (
                    <span className="text-xs font-bold italic text-gray-500 ml-2">
                      – {action.option_instruction}
                    </span>
                  )}
                </>
              }
              name={`actions[${actionIndex}].selected`}
              control={formHandler.control}
              onChange={validateForm}
            />
          );
        })}
      </div>
      <TextareaPp
        title="Message"
        formHandler={formHandler}
        control={formHandler.control}
        onChange={validateForm}
        id="comments"
        placeholder={messagePlaceholder}
        name="comments"
        rules={isMessageRequired ? { required: { value: true, message: "Message is required" } } : undefined}
        errors={submitted && isMessageRequired && !formHandler.getValues().comments?.trim() ? { comments: { message: "Message is required" } } : undefined}
      />

      <div className="flex gap-2 items-center my-5">
        {urgent_message == 1 && (
          <CheckBox
            title="Mark Urgent"
            name="is_urgent"
            control={formHandler.control}
          />
        )}
      </div>

      {uploadProgress != "" ? (
        <div className="mt-1">
          <p>
            <ProgressBarPp progress={uploadProgress} />
          </p>
          <p className="text-left text-sm">{uploadProgress}% Complete</p>
        </div>
      ) : (
        ""
      )}
      {Object.keys(attachments).length ? (
        <div className="mt-2 text-left">
          <h3 className="text-base font-semibold leading-6 text-gray-900">
            Attachments
          </h3>
          <div className="mt-2 flex gap-2">
            {Object.keys(attachments).map((key) => (
              <MsgAttachment
                attachment={attachments[key]}
                remove={() => removeAttachment(key)}
              />
            ))}
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="flex gap-2 items-center mt-2">
        <button
          type="button"
          onClick={sendMessage}
          class="rounded-md bg-blue-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">
          {isLoading ? "Sending" : "Send"}{" "}
          {isLoading && <Icon type="inline-loader" />}
        </button>
        <div class="relative inline-block text-left">
          <div>
            <DropDown
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-5 h-5">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13"
                  />
                </svg>
              }
              menuList={attachmentMenu}
              title="Attach"
            />
          </div>
        </div>
        {/* <button type="button" class="rounded bg-white px-2 py-1 flex gap-2 items-center text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 18.75a6 6 0 0 0 6-6v-1.5m-6 7.5a6 6 0 0 1-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 0 1-3-3V4.5a3 3 0 1 1 6 0v8.25a3 3 0 0 1-3 3Z" />
                    </svg>
                    Record Audio
                </button>
                <button type="button" class="rounded bg-white px-2 py-1 flex gap-2 items-center text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25Z" />
                    </svg>
                    Record Video
                </button> */}
        <input
          type="file"
          onChange={uploadEvent}
          ref={fileInputRef}
          className="h-[0] w-[0]"
        />
      </div>
    </>
  );
};
